import { z } from "zod";

export const SESSION_COOKIE = "b2a_session";
export const LANG_COOKIE = "b2a_lang";
export const SESSION_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;
/** Shared by the sign-in request and AUTHOR_PASSWORD validation so a configured password is always submittable. */
export const PASSWORD_MAX_LENGTH = 1024;

export const SignInRequestSchema = z.strictObject({
  password: z.string().min(1).max(PASSWORD_MAX_LENGTH),
});
export type SignInRequest = z.infer<typeof SignInRequestSchema>;

export const SessionResponseSchema = z.strictObject({
  authenticated: z.literal(true),
});
export type SessionResponse = z.infer<typeof SessionResponseSchema>;

export const SignOutResponseSchema = z.strictObject({
  authenticated: z.literal(false),
});
export type SignOutResponse = z.infer<typeof SignOutResponseSchema>;

export const LOCALES = ["de", "en"] as const;
export const LocaleSchema = z.enum(LOCALES);
export type Locale = z.infer<typeof LocaleSchema>;
export const DEFAULT_LOCALE: Locale = "de";
